import _ from 'lodash'

import {
    CREATE_MAIN_AREA_SUCCESS,
    CREATE_MAIN_AREA_FAILURE,
    CLEAR_MAIN_AREA_KEY_SUCCESS,
    LIST_MAIN_AREAS_FAILURE,
    LIST_MAIN_AREAS_SUCCESS,
    SET_MAIN_AREA_IS_LOADING_SUCCESS,
    SET_MAIN_AREA_SELECTED_SUCCESS,
    SET_MAIN_AREA_ERRORS,
    CLEAR_MAIN_AREA_ERRORS,
    GET_MAIN_AREAS_SUCCESS,
    GET_MAIN_AREAS_FAILURE,
    CLEAR_MAIN_AREA_SUCCESS,
    READ_MAIN_AREA_SUCCESS,
    READ_MAIN_AREA_FAILURE,
    UPDATE_MAIN_AREA_SUCCESS,
    UPDATE_MAIN_AREA_FAILURE, SET_IS_ADD_MAIN_AREA
} from '../actions/main-area'

const mainArea = (state = {}, action) => {
  switch (action.type) {
    case CREATE_MAIN_AREA_SUCCESS:
        return {
            ...state,
            ...action.data
        }
    case CREATE_MAIN_AREA_FAILURE:
    case GET_MAIN_AREAS_SUCCESS:
    return {
      ...state,
      ...action.data
    }
    case GET_MAIN_AREAS_FAILURE:
    case LIST_MAIN_AREAS_SUCCESS:
      return {
        ...state,
        ...action.data,
        [action.data.key]: {
          list: action.data.list
        }
      }
    case SET_MAIN_AREA_IS_LOADING_SUCCESS:
      return {
        ...state,
        [action.data.key]: {
          isLoading: action.data.isLoading
        }
      }
    case SET_MAIN_AREA_SELECTED_SUCCESS:
      return {
        ...state,
        [action.data.key]: {
          selected: action.data.selected
        },
        mainAreaId: action.data.selected[0].id
      }
    case CLEAR_MAIN_AREA_KEY_SUCCESS:
      return _.omit(state, action.data.key)
    case LIST_MAIN_AREAS_FAILURE:
    case SET_MAIN_AREA_ERRORS:
    return {
      ...state,
      ...action.data
    }
    case CLEAR_MAIN_AREA_ERRORS:
    return _.omit(state, 'errors')
    case CLEAR_MAIN_AREA_SUCCESS:
    return _.omit(state, 'current')
    case READ_MAIN_AREA_SUCCESS:
    return {
      ...state,
      ...action.data
    }
    case READ_MAIN_AREA_FAILURE:
    case UPDATE_MAIN_AREA_SUCCESS:
    return state
    case UPDATE_MAIN_AREA_FAILURE:
    case SET_IS_ADD_MAIN_AREA:
         return {
              ...state,
              [action.data.key]: {
                  isAddMainArea: action.data.isAddMainArea
              }
         }
    default:
      return state
  }
}

export default mainArea


// WEBPACK FOOTER //
// ./src/reducers/main-area.js